import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "user-profile" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = { class: "overline" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "overline" }
const _hoisted_6 = { key: 0 }

import {  IonAvatar, IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonMenuButton, IonPage, IonSelect, IonSelectOption, IonTitle, IonToolbar, modalController } from '@ionic/vue';
import { computed,ref} from 'vue';
import { openOutline } from 'ionicons/icons'
import { useStore } from 'vuex';
import TimeZoneModal from '@/views/TimezoneModal.vue';
import Image from '@/components/Image.vue'
import { goToOms, translate } from "@hotwax/dxp-components";
import {getCurrentTime} from "../utils"
import { hasPermission, Actions } from '@/authorization';


export default /*@__PURE__*/_defineComponent({
  __name: 'Settings',
  props: {
  showBrowserTimeZone: {
    type: Boolean,
    default: true
  },
  showDateTime: {
    type: Boolean,
    default: true
  },
  dateTimeFormat: {
    type: String,
    default: 't ZZZZ'
  }
},
  setup(__props) {

const store = useStore()

const userProfile = computed(() => store.getters["user/getUserProfile"])
const currentEComStore = computed(() => store.getters["user/getCurrentEComStore"])
const oms = computed(() => store.getters["user/getInstanceUrl"])
const omsRedirectionInfo = computed(() => store.getters["user/getOmsRedirectionInfo"])
const currentTimeZoneId = computed(() => userProfile.value.timeZone)
const browserTimeZone = ref({
  label: '',
  id: Intl.DateTimeFormat().resolvedOptions().timeZone
})
const props = __props

function setEComStore(event: CustomEvent) {
  if(userProfile.value?.stores) {
    store.dispatch("user/setEcomStore", {
      "productStoreId": event.detail.value
    })
    store.dispatch("rule/clearRuleState")
  }
}

async function changeTimeZone() {
  const timeZoneModal = await modalController.create({
    component: TimeZoneModal,
  });
  return timeZoneModal.present();
}

function logout() {
  store.dispatch("user/logout").then(() => {
    const redirectUrl = window.location.origin + '/login'
    window.location.href = `${process.env.VUE_APP_LOGIN_URL}?isLoggedOut=true&redirectUrl=${redirectUrl}`
  })
}

function goToLaunchpad() {
  window.location.href = `${process.env.VUE_APP_LOGIN_URL}`
}

return (_ctx: any,_cache: any) => {
  const _component_DxpAppVersionInfo = _resolveComponent("DxpAppVersionInfo")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonMenuButton), { slot: "start" }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Settings")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonCard), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), { lines: "full" }, {
                  default: _withCtx(() => [
                    (userProfile.value?.partyImageUrl)
                      ? (_openBlock(), _createBlock(_unref(IonAvatar), {
                          key: 0,
                          slot: "start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Image, {
                              src: userProfile.value.partyImageUrl
                            }, null, 8, ["src"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(IonCardHeader), { class: "ion-no-padding ion-padding-vertical" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCardSubtitle), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(userProfile.value.userId), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonCardTitle), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(userProfile.value?.userFullName), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonButton), {
                  color: "danger",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (logout()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("Logout")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonButton), {
                  "standalone-hidden": !_unref(hasPermission)(_unref(Actions).APP_PWA_STANDALONE_ACCESS),
                  fill: "outline",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (goToLaunchpad()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("Go to Launchpad")) + " ", 1),
                    _createVNode(_unref(IonIcon), {
                      slot: "end",
                      icon: _unref(openOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["standalone-hidden"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", null, _toDisplayString(_unref(translate)('OMS')), 1)
          ]),
          _createElementVNode("section", null, [
            _createVNode(_unref(IonCard), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCardHeader), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCardSubtitle), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)('OMS instance')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCardTitle), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(oms.value), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCardContent), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)('This is the name of the OMS you are connected to right now. Make sure that you are connected to the right instance before proceeding.')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonButton), {
                  disabled: !omsRedirectionInfo.value.token || !omsRedirectionInfo.value.url || !_unref(hasPermission)(_unref(Actions).APP_COMMERCE_VIEW),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goToOms)(omsRedirectionInfo.value.token, omsRedirectionInfo.value.url))),
                  fill: "clear"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)('Go to OMS')) + " ", 1),
                    _createVNode(_unref(IonIcon), {
                      slot: "end",
                      icon: _unref(openOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCard), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCardHeader), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCardSubtitle), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)("Product Store")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCardTitle), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)("Store")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCardContent), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)('A store repesents a company or a unique catalog of products. If your OMS is connected to multiple eCommerce stores sellling different collections of products, you may have multiple Product Stores set up in HotWax Commerce.')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), { lines: "none" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonSelect), {
                      label: _unref(translate)('Select store'),
                      interface: "popover",
                      value: currentEComStore.value.productStoreId,
                      onIonChange: _cache[3] || (_cache[3] = ($event: any) => (setEComStore($event)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((userProfile.value ? userProfile.value.stores : []), (store) => {
                          return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                            key: store.productStoreId,
                            value: store.productStoreId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(store.storeName ? store.storeName : store.productStoreId), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["label", "value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
          _createVNode(_component_DxpAppVersionInfo),
          _createElementVNode("section", null, [
            _createVNode(_unref(IonCard), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCardHeader), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCardTitle), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)('Timezone')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCardContent), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)('The timezone you select is used to ensure automations you schedule are always accurate to the time you select.')), 1)
                  ]),
                  _: 1
                }),
                (__props.showBrowserTimeZone)
                  ? (_openBlock(), _createBlock(_unref(IonItem), { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(translate)("Browser TimeZone")), 1),
                            _createTextVNode(" " + _toDisplayString(browserTimeZone.value.id) + " ", 1),
                            (__props.showDateTime)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(getCurrentTime)(browserTimeZone.value.id, __props.dateTimeFormat)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(IonItem), { lines: "none" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(translate)("Selected TimeZone")), 1),
                        _createTextVNode(" " + _toDisplayString(currentTimeZoneId.value) + " ", 1),
                        (__props.showDateTime)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(getCurrentTime)(currentTimeZoneId.value, __props.dateTimeFormat)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonButton), {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (changeTimeZone())),
                      slot: "end",
                      fill: "outline",
                      color: "dark"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)("Change")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})